import axios from 'axios';
import { PdfStyleDto, ReportTypeDto } from 'models/dtoTypes';
import { API_URL } from 'projectConfig';
import { getAccessToken } from 'auth';
import CurrentUser from 'auth/currentUser';
import { get } from 'lodash';

export default async function downloadKosmosReport({
  companyId,
  organisationId,
  defaultFilename,
  pdfStyle,
  reportType
}: {
  companyId: string;
  organisationId?: string;
  defaultFilename: string;
  pdfStyle: PdfStyleDto;
  reportType: ReportTypeDto;
}) {
  if (!companyId) {
    return;
  }
  const token = await getAccessToken();
  const accessToken = token?.accessToken || '';
  const selected_locale = CurrentUser.getInstance().getLocale();
  if (!accessToken) {
    return;
  }
  const base = `${API_URL}/api/KosmosReport/GetKosmosPdfReport`;
  const query = [
    `companyId=${companyId}`,
    `pdfStyleType=${pdfStyle as string}`,
    `reportType=${reportType as string}`,
    `locale=${selected_locale}`
  ];
  if (organisationId) {
    query.push(`organisationId=${organisationId}`);
  }
  const url = `${base}?${query.join('&')}`;
  const response = await axios({
    url,
    method: 'GET',
    headers: { 'Authorization': 'Bearer ' + accessToken },
    responseType: 'blob', // important
  });
  // const contentDisposition = response.headers['Content-Disposition'];
  // const filename = contentDisposition ? contentDisposition.split('filename=')[1] : defaultFilename;
  const filename = defaultFilename;
  if (response.status === 200) {
    const blob = new Blob([response.data]);
    // Create blob link to download
    // IE10+ : (has Blob, but not a[download] or URL)
    if (get(navigator, 'msSaveBlob')) {
      get(navigator, 'msSaveBlob')(blob, filename);
    } else {
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = filename;
      // Force download
      link.click();
    }
  } else {
    const message = `Download failed: ${response.statusText}`;
    console.error(message);
  }
}


